export default {
  token: state => state.user.token,
  user: state => state.user.user,
  requestNum: state => state.app.requestNum,
}
